<ion-header>
  <ion-toolbar color="subasta-header">
    <ion-title style="height: 56px; font-family: 'Open Sans', sans-serif;color: white;font-weight: 600;font-size:3vh">
      INTRODUCIR
      CANTIDAD </ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-grid style="height: 100%;padding: 0; background-color: aliceblue;">
    <ion-row class="ion-text-left">
      <ion-col class="ion-text-left headers">
        <div class="datoCab verticalLeft">
          <div style="flex:0.1" class="verticalLeft">
            <mat-icon class=" fontVh25" fontSet="fas" fontIcon="fa-fish"></mat-icon>
          </div>
          <div>
            <ion-label class="fontVh25 verticalLeft ">
              {{especie}}
            </ion-label>
          </div>
        </div>
      </ion-col>
    </ion-row>
    <ion-row class="ion-text-left">
      <ion-col class="ion-text-left headers">
        <div class="datoCab verticalLeft">
          <div style="flex:0.1" class="verticalLeft fontVh25">
            €
          </div>
          <div>
            <ion-label class="fontVh25 verticalLeft ">
              {{precio | number:'1.2-2':'es'}}&nbsp;€/{{unidad}}
            </ion-label>
          </div>
        </div>
      </ion-col>
    </ion-row>
    <ion-row class="ion-text-left">
      <ion-col class="ion-text-left headers" style="padding-bottom: 15px;">
        <div class="datoCab verticalLeft">
          <div style="flex:0.1" class="verticalLeft">
            <mat-icon fontSet="fas" class=" fontVh25" fontIcon="fa-weight-hanging"></mat-icon>
          </div>
          <div>
            <ion-label class="fontVh25 verticalLeft ">
              {{cantidad | number:'1.2-2':'es'}}&nbsp;{{unidad}}
            </ion-label>
          </div>
        </div>
      </ion-col>
    </ion-row>
    <ion-row style="margin-top: 10px;margin-bottom: 10px;">
      <ion-col>
        <form [formGroup]="group">
          <ion-row>
            <ion-col class="vertical ion-no-padding">
              <ion-label class="lbl-uprecio vertical">Cantidad&nbsp;{{unidad}}</ion-label>
            </ion-col>
          </ion-row>
          <ion-row class="ion-text-center">
            <ion-col size=12>
               <ion-input label=""    class="in-precio ion-text-end vertical" (ionFocus)="onFocus($event)"
                (ionBlur)="formatNumber('peso')" formControlName="peso" [disabled]="divisible==0">
              </ion-input>
            </ion-col>
            <!-- <ion-input label=""    class="in-precio " (keypress)="numberOnlyValidation($event)" (ionFocus)="onFocus($event)" (ionBlur)="onBlur($event)"  name="cantidadFinal" [value]="cantidad" numeric decimals="2" type="text"></ion-input>-->
          </ion-row>
          <ion-row>
            <ion-col class="vertical ion-no-padding">
              <ion-label class="lbl-uprecio vertical">Cliente</ion-label>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <mat-select class="combo" formControlName="cliente" [disabled]="clientes.length==1">
                <mat-option *ngFor="let client of clientes" [value]="client.id">
                  {{client.nombre}}
                </mat-option>
              </mat-select>
            </ion-col>
          </ion-row>
        </form>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col style="" class="vertical timer">
        Tiempo restante: {{timer}} Seg.
      </ion-col>
    </ion-row>
    <ion-row class="ion-text-center">

      <ion-col>
        <ion-button class="btn-pujar" (click)="confirmarCantidad(true)">Confirmar </ion-button>
      </ion-col>

    </ion-row>
    <ion-row style="margin-top: 10px;">

      <ion-col>
        <ion-button class="btn-anular" (click)="confirmarCantidad(false)">Anular</ion-button>
      </ion-col>

    </ion-row>
  </ion-grid>
</ion-content>